export const getAmountFormatter = (
  precision: number,
  locale = 'cs',
  // Minimum fraction digits floor. Defaults to `precision` (fixed width). Pass a
  // smaller value (e.g. 2) to trim trailing zeros down to it while still showing
  // up to `precision` digits: 0.00000000 -> 0.00, but 0.0001 stays 0.0001.
  minPrecision = precision
) =>
  new Intl.NumberFormat(locale, {
    signDisplay: 'never',
    minimumFractionDigits: Math.min(minPrecision, precision),
    maximumFractionDigits: precision,
  })
